import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import { convertPermissions, loadStatus } from "../util";
import LoadStatus from "../util/loadStatus";

export const getAllPermissions = createAsyncThunk(
  "config/getAllPermissions",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().config;
      if (state.permissions.length <= 0 && state.count.getAllPermissions <= 1) {
        const res = await axios.get("/permissions");
        const newData = convertPermissions(res.data);

        return { permissions: newData, rawPermissions: res.data };
      }
      return {
        permissions: state.permissions,
        rawPermissions: state.rawPermissions,
      };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

const configSlice = createSlice({
  name: "config",
  initialState: {
    loading: false,
    error: null,
    sidebarExpanded: false,
    load: { getAllPermissions: false },
    count: { getAllPermissions: 0 },
    permissions: [],
    rawPermissions: [],
    reformulationItems: [
      {
        value: "description",
        name: "Description",
        type: "html",
      },
      { value: "aim", name: "Aim", type: "html" },
      { value: "purpose", name: "Purpose", type: "html" },
      { value: "activities", name: "Activities", type: "array" },
      { value: "objectives", name: "Objectives", type: "array" },
      {
        value: "expected_results",
        name: "Expected Results",
        type: "array",
      },
      { value: "justification", name: "Justifications", type: "html" },
      { value: "issues", name: "Issues with G7and G8", type: "html" },
      {
        value: "monitoring_supervision",
        name: "Monitoring & Supervision",
        type: "html",
      },
      {
        value: "sustainability_plan",
        name: "Sustainability Plan",
        type: "html",
      },
      {
        value: "selected_indicators",
        name: "Selected Indicators",
        type: "html",
      },
      {
        value: "stakeholder_target_group",
        name: "Stakeholder Target Group",
        type: "text",
      },
      {
        value: "male_beneficiaries",
        name: "Male Beneficiaries",
        type: "text",
      },
      {
        value: "female_beneficiaries",
        name: "Female Beneficiaries",
        type: "text",
      },
      { value: "budget", name: "Budget", type: "budget" },
      {
        value: "catBudget",
        name: "Sub Category Budget",
        type: "category",
      },
    ],
    currencyData: [
      { id: "US Dollar", name: "US Dollar", symbol: "$" },
      { id: "Euro", name: "Euro", symbol: "€" },
      { id: "Cedis", name: "Cedis", symbol: "₵" },
      { id: "CFA Franc", name: "CFA Franc", symbol: "c" },
      { id: "L. Dollar", name: "L. Dollar", symbol: "L$" },
      {
        id: "Leone",
        name: "Leone",
        symbol: "Le",
      },
    ],
  },
  reducers: {
    setSidebarExpanded: (state, action) => {
      state.sidebarExpanded = action.payload;
    },
    setConfigError: (state, action) => {
      state.error = action.payload;
    },
    unsetConfig: (state) => {
      state.permissions = [];
      state.rawPermissions = [];
    },
    addBudgetItem: (state, action) => {
      state.budgetItems.push(action.payload);
    },
    addIncomeItem: (state, action) => {
      state.incomeItems.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Roles
      .addCase(getAllPermissions.pending, (state) => {
        state.load.getAllPermissions = LoadStatus.loading;
        state.error = null;
        state.count.getAllPermissions = ++state.count.getAllPermissions;
      })
      .addCase(getAllPermissions.fulfilled, (state, action) => {
        state.load.getAllPermissions = loadStatus.success;
        state.permissions = action.payload.permissions;
        state.rawPermissions = action.payload.rawPermissions;
        state.count.getAllPermissions = 0;
      })
      .addCase(getAllPermissions.rejected, (state, action) => {
        state.load.getAllPermissions = loadStatus.error;
        state.error = action.payload;
        state.count.getAllPermissions = 0;
      });
  },
});

export const {
  setSidebarExpanded,
  setConfigError,
  unsetConfig,
  addBudgetItem,
  addIncomeItem,
} = configSlice.actions;
export default configSlice.reducer;
